import { FitMode, LayoutType } from '../types';
import { SizeType } from '@/domains/asset';
import { IconName } from '@/components/atoms/Icon';

export const ASPECT_RATIOS: { value: SizeType; label: string }[] = [
  { value: 'LANDSCAPE', label: 'Landscape' },
  { value: 'SQUARE', label: 'Square' },
  { value: 'PORTRAIT', label: 'Portrait' }
];

export const DEFAULT_LAYOUT_OPTION: { value: LayoutType; label: string; icon: IconName } = {
  value: 'DEFAULT',
  label: 'Original',
  icon: 'IconVideo'
};

export const SCENE_LAYOUT_TYPES: { value: LayoutType; label: string; icon: IconName }[] = [
  { value: 'SPEAKER', label: 'Fullscreen', icon: 'IconUserScan' },
  { value: 'GRID', label: 'Grid', icon: 'IconLayoutGrid' },
  { value: 'FOCUS', label: 'Focus', icon: 'IconLayoutSidebarRight' },
  { value: 'PIP', label: 'Picture in Picture', icon: 'IconPictureInPicture' }
];

export const CLIP_CUSTOMIZER_LAYOUT_TYPES = [
  ...SCENE_LAYOUT_TYPES,
  { value: 'AUDIOGRAM', label: 'Audiogram', icon: 'IconPhotoVideo' },
  DEFAULT_LAYOUT_OPTION
];

export const FIT_MODES: { value: FitMode; label: string; icon: IconName }[] = [
  { value: 'FILL', label: 'Fill', icon: 'IconMaximize' },
  { value: 'FIT', label: 'Fit', icon: 'IconSection' }
];

export const BORDER_MODE = [
  { value: true, label: 'Round' },
  { value: false, label: 'Square' }
];

export const SPACING_OPTIONS = [
  { value: '4px', label: '4px' },
  { value: '8px', label: '8px' },
  { value: '10px', label: '10px' },
  { value: '12px', label: '12px' },
  { value: '16px', label: '16px' },
  { value: '20px', label: '20px' },
  { value: '24px', label: '24px' }
];
